import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CANONICAL_HOST = "https://usebrandloop.com";

/**
 * Keeps <link rel="canonical"> in sync with the current route. Ensures search engines
 * index every page under the canonical host (usebrandloop.com), not the emergent.host
 * preview subdomain.
 */
export default function CanonicalUrl() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const href = `${CANONICAL_HOST}${pathname}${search || ""}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
  }, [pathname, search]);

  return null;
}
